import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { loadCollageOrganizations } from '../actions';
import HomeCollage from '../components/HomeCollage';
import { Link } from 'react-router';
import { pushState } from 'redux-router';
import Modal, {closeStyle} from 'simple-react-modal'


class About extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      show: false
    }
  }


  show(){
    this.setState({show: true})
  }

  close(){
    this.setState({show: false})
  }

  componentDidMount() {
    if (typeof(window) !== "undefined") {
      window.scrollTo(0,0)
    }
  }

  render() {
    let buttonCollage = <div onClick={this.show.bind(this)} className="video-play-btn-wrapper">
      <img src="/images/video_play_btn.png" />
    </div>;

    let browser = this.props.browser;

    let aboutModalStyle = {};



    let iframe = '';
    let modalContentStyle = '';
    let closeIcon = '';

    if (this.props.browser.greaterThan.desktop) {

      modalContentStyle = {
        width: '900px',
        height: '707px',
        backgroundColor: 'transparent'
      }

      iframe = <iframe width='900' height='507' src="https://www.youtube.com/embed/ZFlSJZc6fpY?autoplay=1" frameBorder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>

    } else {

      modalContentStyle = {
        paddingBottom: '56.25%',
        width: '100%',
        backgroundColor: 'transparent'
      }

      closeIcon = <div style={{position: 'absolute', top: '-4px', right: '44px'}} onClick={this.close.bind(this)}><img src={'/images/transparent_close.png'}/></div>

      iframe = <iframe style={{position: 'absolute', top: '44px', left: '0', width: '100%', height: '100%'}} src="https://www.youtube.com/embed/ZFlSJZc6fpY?autoplay=1" frameBorder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
    }


    return(
      <main>

        <Modal

          containerStyle={modalContentStyle}
          closeOnOuterClick={true}
          show={this.state.show}
          onClose={this.close.bind(this)}
          transitionSpeed={1000}>

          <a key="close" style={closeStyle} onClick={this.close.bind(this)}>X</a>

          <div key="content">
            {closeIcon}
            <div >
              {iframe}
            </div>
          </div>

        </Modal>


        <div className="content-wrapper">

          <div className="whatWeDo-bannerWrapper">
            <div className="whatWeDo-bannerDesktop">
              <a href="https://youtu.be/ZFlSJZc6fpY?si=FJR8yZMYpIlmnf9y" target="_blank"><img src="images/what_we_do/desktop/whatWeDoBanner_playVideo.png" /></a>
            </div>
            <div className="whatWeDo-bannerMobile">
            <a href="https://youtu.be/ZFlSJZc6fpY?si=FJR8yZMYpIlmnf9y" target="_blank"><img src="images/what_we_do/mobile/whatWeDoBanner_playVideo.png" /></a>
            </div>
          </div>

          <div className="title-wrapper">What We Do</div>
          <div className="aboutUs-wrapper">


            <div className="aboutUs-columnWrapper aboutUs-bodyCopy">

              <p>WorldWideWomen is a for-profit company on a social mission to move the needle toward gender parity. We know that this is a very big goal, but we believe that global connection and access to information and resources are powerful tools to help change the game for women, and that is what we are all about. We work toward this mission in three ways:</p>

              <p><span className="boldText">Global Resource Directory<sup className="bfw-tm" style={{ fontSize: '1.5rem' }}>&nbsp;</sup></span><br />
              The WorldWideWomen team researches and carefully vets valuable organizations, programs and services exclusively for women and assembles them into our easy-to-use directory &mdash; you can search across 10 categories from education and health and wellness to career and business support, motherhood, women’s rights and more and then filter by location. Our directory streamlines the search and quality checking process, and presents &mdash; FOR THE FIRST TIME EVER &mdash; the big picture of all that’s available to support our lives.</p>

              <p><span className="boldText">BuyFromWomen<sup className="bfw-tm" style={{ fontSize: '1.5rem' }}>&trade;</sup></span><br />
              This new directory, created to support and promote women-owned businesses, features exceptional products and services created and offered by women. We intend for this to become a global movement bringing visibility and business to women entrepreneurs and we encourage all of our visitors to consciously buy from women-owned businesses whenever possible.</p>

              <p><span className="boldText">The WorldWideWomen Girls' Festival<sup className="bfw-tm" style={{ fontSize: '1.5rem' }}>&reg;</sup></span><br />
              We bring our website to life through our amazing annual Girls' Festivals (hosted by the WorldWideWomen Foundation), a life-changing day of power and possibility for thousands of girls and their families. The Festivals feature an Expo of local organizations that support girls; all day performances; panel discussions; our own version of Shark Tank for girl entrepreneurs; workshops on topics from human trafficking and health & wellness, to leadership, advocacy, and coding; a STEAM-focused makers fair; sports and fitness arena; speed mentoring and more.</p>

              <p>We plan to include many more services and member offerings to the platform as we grow and scale, so stay tuned. Our ultimate goal is to become the global hub where thousands &mdash; fingers crossed, millions &mdash; of women (and men) come every day to discover and share valuable resources, connect, and collaborate to solve issues impacting our global community of women. It gives us chills!</p>

              <p>Please enjoy,</p>

              <p>The WorldWideWomen team</p>


            </div>

            <div className="aboutUs-columnWrapper aboutUs-statBoxesWrapper">

              <div className="aboutUs-statBox">
                <div className="aboutUs-statBoxInnerWrapper">
                  <div className="aboutUs-statIcon"><img src="/images/pages/about_us/resources.png" /></div>
                  <div className="aboutUs-statCopyWrapper">
                    <div className="aboutUs-statHeader">Total Resources</div>
                    <div className="aboutUs-statNumber">5,478</div>
                  </div>
                </div>
              </div>

              <div className="aboutUs-statBox">
                <div className="aboutUs-statBoxInnerWrapper">
                  <div className="aboutUs-statIcon"><img src="/images/pages/about_us/cities.png" /></div>
                  <div className="aboutUs-statCopyWrapper">
                    <div className="aboutUs-statHeader">Cities</div>
                    <div className="aboutUs-statNumber">23</div>
                  </div>
                </div>
              </div>

              <div className="aboutUs-statBox">
                <div className="aboutUs-statBoxInnerWrapper">
                  <div className="aboutUs-statIcon"><img src="/images/pages/about_us/countries.png" /></div>
                  <div className="aboutUs-statCopyWrapper">
                    <div className="aboutUs-statHeader">Countries</div>
                    <div className="aboutUs-statNumber">13</div>
                  </div>
                </div>
              </div>

            </div>

            <div className="aboutUs-mapWrapper">
              <img src="/images/pages/about_us/map.jpg" />
            </div>

            <div className="aboutUs-talkOfTownWrapper">
              <div className="aboutUs-quoteHeader">
                The talk of the town...
              </div>
              <div className="aboutUs-quote">
                "I'm working and I'm also a mother and I'm trying to figure out how to marry the two. So, having a site like this
                gives me the opportunity to explore what other people have done. Normally, I would just Google, but it comes
                from all over the place, so if there is a site that has all of this vetted information then I can just slowly explore my
                options as a mother and someone who wants to work."
              </div>
            <div className="aboutUs-quoteInnerWrapper">
              <div className="aboutUs-quote quote01">
                "It's about time.
                Why has no one
                done this yet?"
              </div>

              <div className="aboutUs-quote quote02">
                "I love that this is an ‘all
                in one' spot to connect,
                inspire and grow as
                women."
              </div>

              <div className="aboutUs-quote quote03">
                "Oh my, the power of giving
                women this global information
                tool is mind-boggling."
              </div>

              <div className="aboutUs-quote quote04">
                "I see so many
                opportunities to look
                into for my daughter
                and myself."
              </div>
            </div>
            </div>
          </div>
        </div>
      </main>

    )
  }
};

function mapStateToProps(state) {
  return state;
};




export default connect(
  mapStateToProps,
  {
    pushState,
    loadCollageOrganizations
 })(About);



// WEBPACK FOOTER //
// ./src/containers/WhatWeDo.jsx